import React, { useState, useEffect } from "react";
import { Row, Col, Typography } from "antd";
import { useIntl } from "react-intl";

import Schedule from "./schedule";
import LastState from "./lastState";
import ConsignmentInfo from "./consignmentInfo";

const { Title } = Typography;

function History({ full, showInfo, consignmentData }) {
  const intl = useIntl();
  const [lastItem, setLastItem] = useState({});
  useEffect(() => {
    if (consignmentData) {
      setLastItem(consignmentData.history[consignmentData.history.length - 1]);
    }
  }, [consignmentData]);

  return (
    consignmentData && (
      <div>
        {full && (
          <Row gutter={[0, 45]}>
            <Col className="center">
              <Title>
                {intl.formatMessage({
                  id: "tracking.yourConsignment",
                  defaultMessage: "VAŠE ZÁSILKA",
                })}
              </Title>
            </Col>
          </Row>
        )}
        <Row gutter={[20, 45]} type="flex" justify="center">
          {showInfo && (
            <Col sm={24} md={12}>
              <ConsignmentInfo consignment={consignmentData.consignment} />
            </Col>
          )}
          <Col sm={24} md={12}>
            <LastState lastState={lastItem} />
          </Col>
        </Row>
        <Row gutter={[0, 45]}>
          <Col>
            <Schedule history={consignmentData.history} />
          </Col>
        </Row>
      </div>
    )
  );
}

export default History;
